'use strict'

module.exports = {
  READ_WRITE: 'READ_WRITE',
  READ: 'READ',
  WRITE: 'WRITE'
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/dataset-configuration/readWriteModes.js